// collection-filter.js
class CollectionFilter {
  constructor() {
    this.form = document.querySelector('.filter-form');
    this.gridContainer = document.querySelector('.collection-grid');
    this.currentUrl = window.location.href;
    this.setupEventListeners();
  }

  setupEventListeners() {
    // Handle model filter clicks
    document.addEventListener('click', (e) => {
      const link = e.target.closest('.modell-nested-list a');
      if (!link) return;
    
      // Example condition: do NOT hijack if link has a special class or data-attribute
      if (!link.dataset.ajaxFilter) {
        // If there's no "data-ajax-filter", skip the Ajax
        return; // do nothing => normal browser navigation
      }
    
      // If it *does* have the data-ajax-filter, do the Ajax
      e.preventDefault();
      this.handleModelFilter(link);
    });


    // Handle other filter changes
    this.form.addEventListener('change', (e) => {
      if (e.target.matches('input[type="checkbox"], input[type="radio"]')) {
        this.handleFilterChange(e);
      }
    });

    // Handle price range filter
    const priceInputs = this.form.querySelectorAll('input[name="filter.v.price"]');
    priceInputs.forEach(input => {
      input.addEventListener('change', (e) => this.handlePriceFilter(e));
    });
  }

  async handleModelFilter(link) {
    const url = new URL(link.href);
    await this.fetchAndUpdateResults(url);
    this.updateUrlHistory(url);
  }

  async handleFilterChange(event) {
    const formData = new FormData(this.form);
    const url = new URL(window.location.href);
    
    // Update URL with new filter parameters
    formData.forEach((value, key) => {
      if (value) {
        url.searchParams.set(key, value);
      } else {
        url.searchParams.delete(key);
      }
    });

    await this.fetchAndUpdateResults(url);
    this.updateUrlHistory(url);
  }

  async handlePriceFilter(event) {
    const formData = new FormData(this.form);
    const url = new URL(window.location.href);
    
    // Handle price range parameters
    const priceMin = formData.get('filter.v.price.gte');
    const priceMax = formData.get('filter.v.price.lte');
    
    if (priceMin) url.searchParams.set('filter.v.price.gte', priceMin);
    if (priceMax) url.searchParams.set('filter.v.price.lte', priceMax);

    await this.fetchAndUpdateResults(url);
    this.updateUrlHistory(url);
  }

  async fetchAndUpdateResults(url) {
    try {
      const response = await fetch(url, {
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) throw new Error('Network response was not ok');

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Update the collection grid
      const newGrid = doc.querySelector('.collection-grid');
      if (newGrid && this.gridContainer) {
        this.gridContainer.innerHTML = newGrid.innerHTML;
      }

      // Update the active filters display
      this.updateActiveFilters(doc);
      
      // Trigger a custom event for other components
      document.dispatchEvent(new CustomEvent('collection:updated'));

    } catch (error) {
      console.error('Error fetching results:', error);
    }
  }

  updateUrlHistory(url) {
    window.history.pushState({ path: url.href }, '', url.href);
  }

  updateActiveFilters(doc) {
    const activeFiltersContainer = document.querySelector('.tag-list--active-tags');
    const newActiveFilters = doc.querySelector('.tag-list--active-tags');
    
    if (activeFiltersContainer && newActiveFilters) {
      activeFiltersContainer.innerHTML = newActiveFilters.innerHTML;
    }
  }
}

// Initialize the filter functionality when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new CollectionFilter();
});


window.addEventListener('scroll', function () {
  const section = document.getElementById('AjaxContent');
  const child = document.querySelector('.collection-filter');

  // Safety check
  if (!section || !child) return;

  const sectionTop = section.offsetTop;
  const sectionHeight = section.offsetHeight;
  const sectionBottom = sectionTop + sectionHeight;
  const scrollY = window.scrollY;
  const windowHeight = window.innerHeight;

  // Trigger sticky when scrollY passes sectionTop but before sectionBottom && scrollY < sectionBottom - child.offsetHeight
  if (scrollY + 100 >= 150) {
    child.classList.add('cst-sticky');
  } else {
    child.classList.remove('cst-sticky');
  }
});


// document.querySelector('.collection-filter__sort label').addEventListener('click', function (event) {
//     document.querySelector('body').style.overflow = 'hidden';
//     document.querySelector('body').classList.add('overlay-enable');
//     event.target.closest('.collection-filter__sort').querySelector('.cst-sort-by-inner').classList.add('cst-active');
// });

document.addEventListener('click', function (event) {
  const clickedButton = event.target.closest('button#cst-filter-close');
  const clickedButton_1 = event.target.closest('button#cst-sort-close');
  const clickedButton_2 = event.target.closest('.collection-filter__sort label');
  // const filter_btn = event.target.closest('button.collection-filter__btn');

  if (clickedButton) {
    // document.querySelector('body').classList.remove('overlay-enable');
    const targetElement = document.querySelector('.collection-filter__btn');

    if (targetElement) {
      targetElement.click();
    }
  }

  if (clickedButton_1) {
      document.querySelector('body').style.overflow = '';
      document.querySelector('body').classList.remove('overlay-enable');
      event.target.closest('.collection-filter__sort').querySelector('.cst-sort-by-inner').classList.remove('cst-active');
  }

  if (clickedButton_2) {
    document.querySelector('body').style.overflow = 'hidden';
    document.querySelector('body').classList.add('overlay-enable');
    event.target.closest('.collection-filter__sort').querySelector('.cst-sort-by-inner').classList.add('cst-active');
  }

  // if (filter_btn){
  //   document.querySelector('body').classList.add('overlay-enable');
  // }
});

document.addEventListener('click', function (e) {
  // Check if clicked element is a span inside .cst-sort-by-inner
  const span = e.target.closest('.cst-sort-by-inner li span');
  if (!span) return;

  // Skip if already active
  if (span.classList.contains('op-active')) return;

  const selectedValue = span.dataset.value;
  if (!selectedValue) {
    console.warn('data-value not found on span:', span);
    return;
  }

  const select = document.getElementById("SortBy");
  if (!select) {
    console.error('Select element with id="SortBy" not found');
    return;
  }

  // Set select value & trigger change event
  select.value = selectedValue;
  const event = new Event('change', { bubbles: true });
  select.dispatchEvent(event);

  // Close overlay
  document.querySelector('body').style.overflow = '';
  document.querySelector('body').classList.remove('overlay-enable');

  const sortWrapper = span.closest('.collection-filter__sort');
  if (sortWrapper) {
    const inner = sortWrapper.querySelector('.cst-sort-by-inner');
    if (inner) inner.classList.remove('cst-active');
  }

  console.log('Selection updated to:', selectedValue);
});
  